module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073fe_banner_800x600.09a0b3c2.png";